<div style="width: 450px; height: 100px;">    
    <h5 style="margin-left: 10px;margin-top: 10px;">Select the delivery option(s)</h5>
    <div style="display: flex; padding-left: 25px; padding-right: 25px; padding-bottom: 25px;">
        <mat-checkbox color="primary" [(ngModel)]="defaultDeliveryEmail">Email</mat-checkbox>
        <div *ngFor="let option of _deliveryOptions">
            <mat-checkbox color="primary"
                [checked]="selectedDeliveryOption === option.value"
                (change)="additionalDeliveryOption(option.value)">
                {{ option.display }}
            </mat-checkbox>
        </div>
        <!-- [disabled]="!selectedDeliveryOption && !defaultDeliveryEmail" -->
        <button mat-flat-button color="primary" style="margin-left: 10px;" (click)="submitDeliveryOption()" 
        [disabled]="(!selectedDeliveryOption && !defaultDeliveryEmail) || (selectedDeliveryOption === 'WhatsApp' && !defaultDeliveryEmail)">
            Next 
        </button>    
    </div>
</div>